/* eslint-disable @typescript-eslint/no-explicit-any */
import { FC, useEffect, useState } from 'react';
import { DatePicker, Form, message } from 'antd';
import { useNavigate } from 'react-router-dom';
import moment from 'moment';
import { FormContentLayout } from '../FormContentLayout';
// import 'antd/dist/antd.css';
import { openOnboarding } from '../../api/api';
import {
  EddFormType, EddShortSteps, EddSteps,
  LIVE_DATE_FORM_NAME,
} from '../../constants';
import { getUrlParams } from '../../utils/get-url-params';
import styles from './index.module.css';
import { EddLayout } from '../EddLayout';
import { ButtonPair } from '../ButtonPair';

interface LiveDateProps {
  merchantId: string;
}

const NON_SHIPPING_DAYS_TITLE = 'One last thing, when do you want to go live?';
const NON_SHIPPING_DAYS_DESCRIPTION = 'The "Estimated Delivery Date" feature will be live on your product pages at the time you select. You can always change it later by contacting support.';

/** 两天以后的毫秒级时间戳 */
const TWO_DAYS_LATER = Date.now() + 1000 * 60 * 60 * 24 * 2;

const LiveDate: FC<LiveDateProps> = ({ merchantId }) => {
  const form = Form.useFormInstance<EddFormType>();
  const initialValue = moment(TWO_DAYS_LATER);
  const existedFormValue = form.getFieldValue(LIVE_DATE_FORM_NAME);
  const [value, setValue] = useState(existedFormValue || initialValue);
  const handleValueChange = (date: any) => {
    setValue(date);
    form.setFieldValue(LIVE_DATE_FORM_NAME, date);
  };
  const [buttonLoading, setButtonLoading] = useState(false);
  const type = getUrlParams().get('type');
  const dataSufficient = type === 'data-sufficient';
  const navigate = useNavigate();

  const handleSubmit = () => {
    setButtonLoading(true);
    const formData = form.getFieldsValue();
    /** live date 数据类型转换 moment --> timestamp in ms */
    const liveDateTimeStamp = formData.liveDateTimeStamp.valueOf();
    const onboardingForm = { ...formData, liveDateTimeStamp, automaticCalculate: dataSufficient };
    openOnboarding({
      merchantId,
      eddOnboardingForm: onboardingForm,
    }).then((res) => {
      const [hasError, data] = res;
      if (hasError) {
        message.error('An Error Occurred');
        return;
      }
      if (data?.code === 0) {
        navigate('/edd/application/submitted');
      }
    }).catch((err) => {
      message.error('An Error Occurred');
      console.error('err', err);
    }).finally(() => setButtonLoading(false));
  };

  useEffect(() => {
    /** 首次进入页面需要将初始值设置到表单中，此时表单中没有值 */
    if (!existedFormValue) {
      form.setFieldValue(LIVE_DATE_FORM_NAME, initialValue);
    }
  }, []);

  return (
    <EddLayout left={(
      <FormContentLayout
        title={NON_SHIPPING_DAYS_TITLE}
        description={NON_SHIPPING_DAYS_DESCRIPTION}
        step={dataSufficient ? EddShortSteps.FINAL : EddSteps.FINAL}
        dataSufficient={dataSufficient}
      >
        <div className={styles.date}>Date</div>
        <DatePicker className={styles.datePicker} value={value} onChange={handleValueChange} />
        <ButtonPair
          step={dataSufficient ? EddShortSteps.FINAL : EddSteps.FINAL}
          disableNext={!value}
          dataSufficient={dataSufficient}
          onSubmit={handleSubmit}
          loading={buttonLoading}
        />
      </FormContentLayout>
    )}
    />
  );
};

export { LiveDate };
